import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/users')({
  staticData: { breadcrumb: 'Users', breadcrumbKey: 'K_BREADCRUMB_USERS' },
});
